import { render, staticRenderFns } from "./dep.vue?vue&type=template&id=2b2b94a8&scoped=true&"
import script from "./dep.vue?vue&type=script&lang=js&"
export * from "./dep.vue?vue&type=script&lang=js&"
import style0 from "./dep.vue?vue&type=style&index=0&id=2b2b94a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2b94a8",
  null
  
)

export default component.exports